import { AlertTriangle } from "lucide-react";

import { Button } from "@/components/ui/button";

// ponytail: single branded error UI shared by the root + dashboard error boundaries.
// Replaces the raw <pre>{error.message}</pre> dumps. `reset` is passed by TanStack
// Router's errorComponent when available; falls back to a full reload.
export function AppErrorBoundary({ error, reset }: { error: Error; reset?: () => void }) {
  return (
    <div
      role="alert"
      className="flex min-h-screen w-full flex-col items-center justify-center gap-4 p-6 text-center"
    >
      <AlertTriangle className="text-destructive size-10" />
      <div className="space-y-1">
        <h1 className="text-xl font-semibold">Something went wrong</h1>
        <p className="text-muted-foreground max-w-md text-sm leading-6">
          An unexpected error interrupted this page. Your data is safe. Try again, or contact
          support if it keeps happening.
        </p>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-2">
        <Button onClick={() => (reset ? reset() : window.location.reload())}>Try again</Button>
        <Button variant="outline" asChild>
          <a href="/">Go home</a>
        </Button>
        <Button variant="ghost" asChild>
          <a href="mailto:hello@tuzidi.net?subject=TaxOS%20error%20report">Contact support</a>
        </Button>
      </div>
      <details className="text-muted-foreground mt-2 w-full max-w-md text-left text-xs">
        <summary className="cursor-pointer">Technical detail</summary>
        <pre className="border-border mt-2 overflow-auto whitespace-pre-wrap rounded-md border p-3">
          {error.message}
        </pre>
      </details>
    </div>
  );
}
